import type React from "react";

import type { LicenseTier } from "../../../schemas";
import type { LicensedProductCategoryName } from "../../../types";
import { useUser } from "../../../hooks";

interface LicensedCommonProps {
	readonly productCategory: LicensedProductCategoryName;
	readonly tier: LicenseTier;
	readonly licenseFeatureFlag?: string | string[];
	readonly bypassForPacksizeUser?: boolean;
	readonly bypassForPacksizePartner?: boolean;
}

interface LicensedWithoutFallbackProps extends LicensedCommonProps {
	readonly children: React.ReactNode;
	readonly fallback?: never;
}

interface LicensedWithFallbackProps extends LicensedCommonProps {
	readonly children?: React.ReactNode;
	readonly fallback: React.ReactNode;
}

type LicensedProps = LicensedWithoutFallbackProps | LicensedWithFallbackProps;

export const Licensed: React.FC<LicensedProps> = ({
	children = null,
	productCategory,
	tier,
	licenseFeatureFlag,
	bypassForPacksizeUser,
	bypassForPacksizePartner,
	fallback = null,
}) => {
	const { hasLicense, isPacksizeUser, isPacksizePartner } = useUser();

	if (bypassForPacksizeUser === true && isPacksizeUser === true) {
		return children;
	}

	if (bypassForPacksizePartner === true && isPacksizePartner === true) {
		return children;
	}

	const licenseCheck = hasLicense(productCategory, tier, licenseFeatureFlag);

	if (licenseCheck === undefined) {
		return null;
	}

	if (licenseCheck === false) {
		return fallback;
	}

	return children;
};
